export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FINBERRY_API_KEY,
  authDomain: process.env.REACT_APP_FINBERRY_AUTH_DOM,
  projectId: process.env.REACT_APP_FINBERRY_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FINBERRY_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FINBERRY_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FINBERRY_APP_ID,
};
